export default __webpack_public_path__ + "static/media/Preview1.e873f534.jpg";